module.exports = __webpack_public_path__ + "img/feature-05-community.e7f8c8ac.svg";